/**
 * Einheitlicher Debug-Schalter (Welle 7e7).
 *
 * Aktivieren:  ?debug=1  in der URL  → wird in localStorage persistiert
 *              oder im Console:  bamoa.verbose(true)
 * Deaktivieren: ?debug=0  oder  bamoa.verbose(false)
 *
 * Im Debug-Modus loggen alle Schichten ausführlich (RTC-State, SFrame-Statistik,
 * Verbindungsinfo, Signaling). Ohne Debug bleiben nur Meilensteine + Warnungen.
 * Gedacht für Feldanalyse beim Kunden: Flag setzen, Problem reproduzieren, Logs sichern.
 */
let cached: boolean | null = null;

export function debugEnabled(): boolean {
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get('debug');
    if (q === '1' || q === 'true') { localStorage.setItem('bamoa_debug', '1'); cached = true; return true; }
    if (q === '0' || q === 'false') { localStorage.removeItem('bamoa_debug'); cached = false; return false; }
    if (cached !== null) return cached;
    cached = localStorage.getItem('bamoa_debug') === '1';
    return cached;
  } catch { return false; }
}

export function setDebug(on: boolean): boolean {
  try {
    if (on) localStorage.setItem('bamoa_debug', '1');
    else localStorage.removeItem('bamoa_debug');
    cached = on;
    console.log(`%cBamoa Debug-Modus ${on ? 'AKTIV' : 'aus'}`, 'color:#fff;background:#b45309;padding:2px 6px;border-radius:3px;font-weight:bold');
  } catch { /* ignore */ }
  return on;
}

/** Ausführliches Log — nur sichtbar im Debug-Modus. */
export function dlog(...args: unknown[]): void {
  if (debugEnabled()) console.log('[dbg]', ...args);
}
